import React from "react";
import { useNavigate } from "react-router-dom";
import Card from "../Card/Card";

function Pesquisado({ resultados, limpar }) {
  const navigate = useNavigate();

  // Função para ir à página de detalhes
  function irParaDetalhes(id) {
    navigate(`/projeto/${id}`);
  }

  return (
    <main style={{ padding: 20 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <h1>Resultados da pesquisa</h1>
        <button onClick={limpar}>Voltar ao Inicio</button>
      </div>

      {resultados.length === 0 ? (
        <p>Nenhum resultado encontrado.</p>
      ) : (
        <div
          className="cards-container"
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: 12,
            marginTop: 20,
          }}
        >
          {resultados.map((p) => (
            <Card
              key={p.id}
              projeto={p}
              onClick={() => irParaDetalhes(p.id)} // mesmo comportamento do Inicial
            />
          ))}
        </div>
      )}
    </main>
  );
}

export default Pesquisado;
